function openPdfFromBase64(base64) {
  const cleanBase64 = base64.replace(/^data:application\/pdf;base64,/, "");

  const byteCharacters = atob(cleanBase64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });

  const blobUrl = URL.createObjectURL(blob);
  const pdfWindow = window.open(blobUrl, "_blank")

  if(pdfWindow) {
    const timer = setInterval(() => {
      if (pdfWindow.closed) {
        URL.revokeObjectURL(blobUrl);
        clearInterval(timer);
      }
    }, 1000);
  }
}

export default openPdfFromBase64;
